export default class HttpCallConfig {
  public successMessage?: string
  public disableErrorMessageing?: boolean
  public enforceErrorPage?: boolean
  public successCallBack?: () => void
}



// WEBPACK FOOTER //
// ./src/modules/core/models/HttpCallConfig.ts